/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import {defineMessages, FormattedMessage, useIntl} from "react-intl";
import {ErrorMessage, Field, Formik, getIn} from "formik";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons";

/* Helpers, constants, custom methods, internal libraries */
import {
  createValidationPolicyYupSchema,
  useValidationService
} from "../../../resources/validations/validations";
import { colors } from "../../../constants/colors";
import { useHasPermission } from "../../../hooks/useHasPermission";

/* Components */
import { ReactComponent as DeleteTeamSvg } from '../../../resources/images/trash-edit-team.svg';

/* Styles */
import styles from "./styles.js"


const messages = defineMessages({
  teamNamePlaceholderMessage: {
    id: 'createTeam.teamName'
  },
})

const Content = props => {
  const { setShowModal, handleEditTeam, setShowDeleteTeamModal, isDefault, setShowDeleteDefaultTeamModal, teamId, companyEntityId, teamName, sameGroupName, setSameGroupName } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const { checkPermission } = useHasPermission();

  const formRef = useRef(null);
  const intl = useIntl();

  const { editTeamMockedValidationObj } = useValidationService()
  const [testSchema, setTestSchema] = useState({});

  useEffect(() => {
    //TODO: api call to get validations //simpleMockedApiValidationObj
    const result = createValidationPolicyYupSchema(editTeamMockedValidationObj);
    setTestSchema(result)
  }, [])

  const handleFormSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  const submitForm = (values, setSubmitting) => {
    handleEditTeam(values)
    setSubmitting(false);
  }

  const handleDeleteTeam = () => {
    setShowModal(false)
    isDefault ? setShowDeleteDefaultTeamModal(true) : setShowDeleteTeamModal(true)
  }

  const groupNameChange = (e, handleChange, setFieldValue) => {
    setSameGroupName(false)
    const value = e.target.value;
    handleChange(e);
    setFieldValue("groupName", value);
  };

  return (
    <div className={classes.modalContent}>
      <Formik
        innerRef={formRef}
        initialValues={{
          teamId: teamId,
          companyEntityId: companyEntityId,
          groupName: teamName
        }}
        validationSchema={testSchema}
        onSubmit={(values, { setSubmitting }) => {
          submitForm(values, setSubmitting);
        }}
      >
        {({
          values,
          errors,
          touched,
          setFieldTouched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
            setFieldValue
          }) => (

          <>
            <form onSubmit={handleSubmit} >
              <div className={classes.inputContainer}>
                <label htmlFor="groupName" className={classes.label}>
                  <FormattedMessage id="editTeam.name"/>
                </label>
                <Field
                  placeholder={intl.formatMessage(messages.teamNamePlaceholderMessage)}
                  type="groupName"
                  name="groupName"
                  id="groupName"
                  onChange={(e) =>
                    groupNameChange(e, handleChange, setFieldValue)
                  }
                  className={
                    (errors.groupName && touched.groupName) || sameGroupName
                      ? "input-error"
                      : null
                  }
                />
                <ErrorMessage
                  name="groupName"
                  component="span"
                  className={classes.error}
                />
                {
                  sameGroupName &&
                  <div className={classes.nameError}>
                    <FormattedMessage id="editTeam.sameEmailError"/>
                  </div>
                }
              </div>
              <div className={classes.btnContainer}>
                <ContainerFluid>
                  <Row>
                    <Col className={classes.colCancel}>
                      <UCButton
                        onClick={() => setShowModal(false)}
                        type="default"
                        className={classes.cancelBtn}
                        text={<FormattedMessage id="editTeam.cancel"/>}
                        tabIndex={0}
                      />
                    </Col>
                    <Col className={classes.colRemove} >
                      <UCButton
                        className={classes.createBtn}
                        onClick={handleFormSubmit}
                        type="primary"
                        text={<FormattedMessage id="editTeam.update"/>}
                        spinner={{
                          name: "editTeamSpinner",
                          size: 20,
                        }}
                        tabIndex={0}
                      />
                    </Col>
                  </Row>
                </ContainerFluid>
              </div>
            </form>
          </>
        )}
      </Formik>
      <div className={classes.dividerContainer}>
        <hr className={classes.border}/>
      </div>
      <div className={classes.deleteContainer}>
        {
          checkPermission("F_DELETE_GROUP") &&
            <UCButton
              className={classes.deleteBtn}
              onClick={() => handleDeleteTeam()}
              type="default"
              text={
                <div className={classes.deleteText}>
                  <DeleteTeamSvg />
                  <FormattedMessage id="editTeam.deleteTeam"/>
                </div>
              }
            />
        }

      </div>
    </div>
  )
}

export default Content;
